// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { renameGroupName as renameGroupNameApi, RenameGroupName } from "@bg/App/Services/QuoteService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import loadQuote from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuote";

interface Props {
    apiParameter: RenameGroupName;
    apiResult: { successful: boolean; error?: any };
}

type Parameter = RenameGroupName & {
    reloadCart?: boolean;
    reloadQuote?: boolean;
    onComplete?: (result: any) => void;
    onError?: (e: any) => void;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginAction: HandlerType = props => {
    props.dispatch({
        type: "Data/Quotes/BeginLoadQuote",
        quoteId: props.parameter.cartId,
    });
    props.apiParameter = {
        cartId: props.parameter.cartId,
        originalGroupName: props.parameter.originalGroupName,
        newGroupName: props.parameter.newGroupName,
    };
};

export const CallApiWithParameters: HandlerType = async props => {
    props.apiResult = await renameGroupNameApi(props.apiParameter);
};

export const ReloadCartOnSuccess: HandlerType = props => {
    if (props.apiResult.successful && props.parameter.reloadCart) {
        props.dispatch(loadCurrentCart());
    }
};

export const ReloadQuoteOnSuccess: HandlerType = props => {
    if (props.apiResult.successful && props.parameter.reloadQuote) {
        props.dispatch(loadQuote({ quoteId: props.parameter.cartId }));
    }
};

export const CallOnComplete: HandlerType = props => {
    if (props.apiResult.successful && props.parameter.onComplete) {
        props.parameter.onComplete(props.apiResult);
    }
};

export const chain = [
    DispatchBeginAction,
    CallApiWithParameters,
    ReloadCartOnSuccess,
    ReloadQuoteOnSuccess,
    CallOnComplete,
];

const renameGroup = createHandlerChainRunner(chain, "RenameGroup");
export default renameGroup;
